<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        Add airport
      </h3>

      <validation-observer ref="airport-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="id"
              v-slot="{ errors }">
              <label for="id">Airport:</label>
              <div :class="{ 'form-control': true, 'is-select': true }">
                <v-select
                  :options="$root.enabledAirports"
                  v-model="data.id"
                  :reduce="airport => airport.id"
                  placeholder="Select an airport"
                  :filterBy="filterByAirports"
                  :maxItemsDisplay="100"
                  label="id">
                  <template slot="no-options">
                    There are no airports for the provided phrase&hellip;
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.icao }} ({{ option.name }})
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.icao }} ({{ option.name }})
                    </div>
                  </template>
                </v-select>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'AirportPopup',
  data () {
    return {
      isVisible: false,
      loading: false,
      airports: [],
      emptyResults: false,
      data: {
        id: null,
        reference_id: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-airport-popup', this.show);
  },
  methods: {
    filterByAirports (option, label, search) {
      return (option.name + ' ' + option.icao).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    show (referenceId = false) {
      this.data = {
        id: null,
        reference_id: referenceId
      };

      setTimeout(() => {
        this.isVisible = true;
        this.$refs['airport-form'].reset();
      }, 100);
    },
    validateForm () {
      FormUtils.validate(this.$refs['airport-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let endpointUrl = '/handlers/add-airport/' + this.data.reference_id;
      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Airport added',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the airport for this agent. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('airports-list-reload');
          this.$refs['airport-form'].reset();
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let dataToSend = {
        airport_id: this.data.id
      };

      return dataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-airport-popup', this.show);
  }
}
</script>
